import { type PaymentProvider } from '@/types/IPaymentProvider';

export const getPaymentProviderLabelPreview = (
  provider: PaymentProvider
): string => {
  const labels: Record<PaymentProvider, string> = {
    yookassa: 'Yookassa',
    sber_pay: 'SberPay',
    dolymi: 'Долями',
    card_online: 'Карта Онлайн',
    tinkoff_pay: 'Tinkoff Pay',
    yandex_pay: 'Yandex Pay',
    sbp: 'СБП',
    yandex_split: 'Яндекс Сплит',
    sberbank: 'Сбербанк',
    cash: 'Наличные',
    card_receipt: 'Карта по чеку',
    mokka: 'Мокка'
  };
  return provider in labels ? labels[provider] : 'Неизвестно';
};
